(function(){
  function init(){
    document.querySelectorAll('.sc-comp__slider').forEach(function(slider){
      var after = slider.querySelector('.sc-comp__after');
      var handle = slider.querySelector('.sc-comp__handle');
      var dragging = false;

      function setPos(clientX){
        var rect = slider.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }

      slider.addEventListener('pointerdown', function(e){
        dragging = true;
        slider.setPointerCapture(e.pointerId);
        setPos(e.clientX);
      });
      slider.addEventListener('pointermove', function(e){
        if (!dragging) return;
        setPos(e.clientX);
      });
      slider.addEventListener('pointerup', function(){ dragging = false; });
      slider.addEventListener('pointercancel', function(){ dragging = false; });
    });

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.sc-pd-mini__slot').forEach(function(slot, slotIndex){
      var items = slot.querySelectorAll('.sc-pd-mini__item');
      if (items.length < 2 || reduceMotion) return;
      var idx = 0;
      setInterval(function(){
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, 3800 + slotIndex * 300);
    });

    initTierInfo();
    initColorSwatches();
    initColorDropdown();
  }

  var COLOR_SWATCHES = {
    'negro': '#1a1a1a',
    'negro y dorado': 'linear-gradient(135deg,#1a1a1a 50%,#c9a227 50%)',
    'azul y negro': 'linear-gradient(135deg,#1a1a1a 50%,#2461c7 50%)',
    'rosa arcoíris': 'linear-gradient(135deg,#ff5fa2,#ffd166 33%,#6ee7d8 66%,#7c83fd)',
    'rojo': '#d81e2c',
    'rojo ámbar': 'linear-gradient(135deg,#d81e2c 50%,#e8912a 50%)',
    'blanco y rosa': 'linear-gradient(135deg,#f4f4f4 50%,#ff9ec7 50%)',
    'blanco y azul': 'linear-gradient(135deg,#f4f4f4 50%,#4cc9f0 50%)',
    'rosa cristal': 'linear-gradient(135deg,#ffd7ea,#ff8fc7)',
    'negro y turquesa': 'linear-gradient(135deg,#1a1a1a 50%,#14b8a6 50%)',
    'fotocromática gris': 'linear-gradient(135deg,#c9ccd1,#4b4f56)'
  };

  // AutoDS importa los colores con el código de AliExpress; aquí se muestran con su nombre.
  var COLOR_NAMES = {
    'black-04': 'Negro',
    'eu-dz-s1412-ph-go-04': 'Negro y Dorado',
    'eu-dz-s1412-ph-bl-02': 'Azul y Negro',
    'eu-dz-s1412-ph-pi-19': 'Rosa Arcoíris',
    'red-01': 'Rojo',
    'eu-dz-s1412-ph-re-01': 'Rojo Ámbar',
    'pink-17': 'Blanco y Rosa',
    'blue-09': 'Blanco y Azul',
    'pink-24': 'Rosa Cristal',
    'blue-02': 'Negro y Turquesa',
    'photochromic-12': 'Fotocromática Gris'
  };

  function labelNameNode(label){
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }

  function hideSingleValueOptions(){
    document.querySelectorAll('fieldset.product-form__input').forEach(function(fs){
      var legend = fs.querySelector('legend');
      if (legend && legend.textContent.trim().toLowerCase() === 'color') return;
      if (fs.querySelectorAll('input[type="radio"]').length <= 1) fs.style.display = 'none';
    });
  }

  function initColorSwatches(){
    hideSingleValueOptions();
    var fieldset = document.querySelector('fieldset.product-form__input--pill');
    if (!fieldset || fieldset.querySelector('legend')?.textContent.trim().toLowerCase() !== 'color') return;

    fieldset.querySelectorAll('label').forEach(function(label){
      var nodo = labelNameNode(label);
      if (nodo) {
        var original = nodo.textContent.trim().toLowerCase();
        if (original === '2-pack-0224') {
          label.style.display = 'none';
          var inputPack = label.previousElementSibling;
          if (inputPack && inputPack.tagName === 'INPUT') inputPack.style.display = 'none';
          return;
        }
        if (COLOR_NAMES[original]) nodo.textContent = COLOR_NAMES[original];
      }
      if (label.querySelector('.sc-color-dot')) return;
      var nombre = nodo ? nodo.textContent.trim() : label.textContent.trim();
      var fondo = COLOR_SWATCHES[nombre.toLowerCase()];
      if (!fondo) return;
      var dot = document.createElement('span');
      dot.className = 'sc-color-dot';
      dot.style.background = fondo;
      dot.setAttribute('aria-hidden', 'true');
      label.insertBefore(dot, label.firstChild);
    });
  }

  function initColorDropdown(){
    var fieldset = document.querySelector('fieldset.product-form__input--pill');
    if (!fieldset) return;
    var legend = fieldset.querySelector('legend');
    var legendText = legend ? legend.textContent.trim() : 'Color';

    var wrapper = fieldset.parentElement;
    var trigger;
    if (!wrapper || !wrapper.classList.contains('sc-color-dropdown')) {
      wrapper = document.createElement('div');
      wrapper.className = 'sc-color-dropdown';
      fieldset.parentNode.insertBefore(wrapper, fieldset);
      wrapper.appendChild(fieldset);

      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'sc-color-trigger';
      trigger.innerHTML =
        '<span class="sc-color-trigger__dot" aria-hidden="true"></span>' +
        '<span class="sc-color-trigger__label"></span>' +
        '<svg class="sc-color-trigger__chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrapper.insertBefore(trigger, fieldset);
      fieldset.classList.add('sc-color-panel');

      trigger.addEventListener('click', function(){
        wrapper.classList.toggle('is-open');
      });
      fieldset.addEventListener('click', function(e){
        if (e.target.closest('label')) {
          setTimeout(function(){ syncTrigger(); wrapper.classList.remove('is-open'); }, 0);
        }
      });
      document.addEventListener('click', function(e){
        if (!wrapper.contains(e.target)) wrapper.classList.remove('is-open');
      });
    } else {
      trigger = wrapper.querySelector('.sc-color-trigger');
    }

    function syncTrigger(){
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var label = checked ? checked.nextElementSibling : null;
      var dot = label ? label.querySelector('.sc-color-dot') : null;
      var nombre = legendText;
      if (label) {
        var texto = label.childNodes[label.childNodes.length - 1];
        nombre = (label.textContent || '').replace('Variante agotada o no disponible', '').trim();
      }
      trigger.querySelector('.sc-color-trigger__label').textContent = nombre;
      trigger.querySelector('.sc-color-trigger__dot').style.background = dot ? dot.style.background : '';
    }

    syncTrigger();
  }

  // Las tarjetas Simple/Dúo/Trío son solo informativas (el precio de Dúo/Trío
  // se aplica como descuento automático en el carrito al añadir 2 o 3
  // unidades del mismo color, no son variantes distintas). Aquí solo se
  // recalcula el texto de precio de cada tarjeta según el color elegido.
  function initTierInfo(){
    var wrap = document.querySelector('.sc-pd-tiers');
    if (!wrap) return;

    var DESCUENTO_DUO = 999;   // céntimos
    var DESCUENTO_TRIO = 2198; // céntimos

    function money(cents){
      return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    }

    function qtyInput(){ return document.querySelector('input.quantity__input[name="quantity"]'); }

    function syncActiva(){
      var input = qtyInput();
      var valor = input ? String(parseInt(input.value, 10) || 1) : '1';
      wrap.querySelectorAll('.sc-pd-tier').forEach(function(card){
        var activa = card.getAttribute('data-unidades') === valor;
        card.classList.toggle('is-activa', activa);
        card.setAttribute('aria-pressed', activa ? 'true' : 'false');
      });
    }

    function elegir(n){
      var input = qtyInput();
      if (!input) return;
      input.value = n;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncActiva();
    }

    if (!wrap.dataset.scClicks) {
      wrap.dataset.scClicks = 'true';
      wrap.addEventListener('click', function(e){
        var card = e.target.closest('.sc-pd-tier');
        if (card) elegir(card.getAttribute('data-unidades'));
      });
      wrap.addEventListener('keydown', function(e){
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.sc-pd-tier');
        if (card) { e.preventDefault(); elegir(card.getAttribute('data-unidades')); }
      });
      document.addEventListener('change', function(e){
        if (e.target && e.target.matches && e.target.matches('input.quantity__input')) syncActiva();
      });
    }
    syncActiva();

    function render(variant){
      if (!variant || !variant.price) return;
      var precios = {
        '1': variant.price,
        '2': (variant.price * 2) - DESCUENTO_DUO,
        '3': (variant.price * 3) - DESCUENTO_TRIO
      };
      var imgSrc = variant.featured_image ? variant.featured_image.src : '';
      wrap.querySelectorAll('.sc-pd-tier').forEach(function(card){
        var unidades = card.getAttribute('data-unidades');
        var precioEl = card.querySelector('.sc-pd-tier__precio');
        if (precioEl && precios[unidades] != null) precioEl.textContent = money(precios[unidades]);
        var udEl = card.querySelector('.sc-pd-tier__ud');
        if (udEl && precios[unidades] != null) udEl.textContent = money(precios[unidades] / Number(unidades)) + '/ud.';
        if (imgSrc) {
          card.querySelectorAll('.sc-pd-tier__imgs img').forEach(function(img){ img.src = imgSrc; });
        }
      });
    }

    // Dawn publica este evento cada vez que termina de refrescar precio/variante
    // tras un cambio de color, incluso después de reemplazar el <variant-selects>.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(evt){ render(evt.data.variant); initColorSwatches(); initColorDropdown(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
